import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight: 100,
    backgroundColor: '#fff',
    border: '1px solid rgba(240, 240, 240, 1)',
    borderRadius: 4,
    padding: 16,
    textAlign: 'left',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: 4,
  },
  title: {
    marginLeft: 8,
    fontSize: 16,
    lineHeight: '16px',
    fontWeight: 700,
  },
  subtitle: {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.45)',
    lineHeight: 1.25,
  },
  disabled: {
    opacity: 0.4,
  },
  new: {
    marginLeft: 'auto',
    backgroundColor: '#FAAD14 ',
    fontSize: 11,
    padding: '3px 8px',
    borderRadius: 16,
  },
}));

type ButtonProps = {
  id: string;
  title: string;
  subtitle: string;
  onClick?: () => void;
  icon: React.ReactNode;
  isNew?: boolean;
};

export const ButtonRedirect = ({ id, onClick, title, subtitle, icon, isNew }: ButtonProps) => {
  const classes = useStyles();
  return (
    <button id={id} onClick={onClick || null} className={classes.root}>
      <div className={classes.header}>
        <div>{icon}</div>
        <p className={classes.title}>{title}</p>
        {isNew && <span className={classes.new}>Novidade</span>}
      </div>
      <p className={classes.subtitle}>{subtitle}</p>
    </button>
  );
};
